<div class="nxe-list" nxeDragDrop (dragging)="dragging = $event">
  <div class="nxe-list-drag" [ngClass]="{ dragging: dragging }"></div>
  <div class="nxe-list-backpad" (click)="emptySpaceClick()"></div>
  <div class="nxe-list-container drop-list_ pp0" [id]="parentItem.id+''" [class.dragging-element]="draggingelement"
    cdkDropList [cdkDropListConnectedTo]="connectedIds" cdkDropListSortingDisabled>

    <!-- tabella larga: scorre in orizzontale sugli schermi stretti -->
    <div class="nxe-list-wrapper table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{ 'filemanager.ui.col_name' | translate }}</th>
            <th scope="col">{{ 'filemanager.ui.col_type' | translate }}</th>
            <th scope="col">{{ 'filemanager.ui.col_size' | translate }}</th>
            <th scope="col">{{ 'filemanager.ui.col_modified' | translate }}</th>
            <th scope="col">{{ 'filemanager.ui.col_assistant' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Riga per risalire alla cartella superiore (anche zona di rilascio) -->
          @if(parentObj) {
          <tr class="drop-list-folder nxe-list-row-up" [ngClass]="{ 'nxe-list-row-selected': isSelected(parentObj) }"
          (dblclick)="open($event, parentObj)"
          (click)="folderClick($event, parentObj)">
            <td colspan="5">
              <div class="drop-list-folder">
                <div class="drop drop-list drop-zone pp1" [id]="parentObj.id+''" cdkDropList
                  [cdkDropListData]="parentObj" [cdkDropListConnectedTo]="connectedButMe(parentObj)"
                  (cdkDropListDropped)="onDragDropParent($event,parentObj)">
                </div>
                <div class="nxe-icons-wrapper"
                  [id]="'parentDroplist_'+parentObj.id" cdkDrag [cdkDragDisabled]="isSelected(parentObj)">
                  <div class="nxe-icons-wrapper-inner" [title]="'filemanager.ui.parent_folder' | translate">
                    <div class="nxe-icons-icon nxe-kind nxe-kind--sm nxe-kind--folder">
                      <i-tabler class="icon-18" name="arrow-up"></i-tabler>
                    </div>
                    <div class="nxe-icon-text">{{ 'filemanager.ui.parent_folder' | translate }}</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          }

          @for (item of items; track $index) {
            @if (item.isLeaf) {
            <!-- File trascinabile -->
            <tr class="drag-item-leaf" [ngClass]="{ 'nxe-list-row-selected': isSelected(item) }"
            (dblclick)="open($event, item)"
             (click)="select($event, item)"
             (cdkDragStarted)="onDragStart($event, item)"
              [cdkDragData]="selectedNodes" cdkDrag
              [id]="item.id"
            >
              <td class="nxe-list-name">
                <div class="drag-item nxe-icons-wrapper">
                  <div class="nxe-icons-wrapper-inner" [title]="item.name">
                    <div class="nxe-icons-icon nxe-kind nxe-kind--sm" [ngClass]="'nxe-kind--' + fileKind(item).tone" cdkDragHandle>
                      {{ fileKind(item).label }}
                    </div>
                    <div class="nxe-icon-text">{{ item.name }}</div>
                  </div>
                  <div *cdkDragPreview>
                    @for(node of selectedNodes; track $index){
                      <div class="drag-item-preview">
                        <i-tabler class="icon-24 icon-file" name="file"></i-tabler>
                        <div class="nxe-icon-text">{{ node.name }}</div>
                      </div>
                    }
                  </div>
                  <div class="nxe-list-placeholder" *cdkDragPlaceholder></div>
                </div>
              </td>
              <td>{{ fileKind(item).typeKey | translate }}</td>
              <td class="nxe-list-nowrap">{{ fileSize(item) }}</td>
              <td class="nxe-list-nowrap">{{ modifiedAt(item) }}</td>
              <td>
                @if (isRagSupported(item)) {
                  <div class="rag-actions" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                    <span class="xr-badge" [ngClass]="ragBadgeClass(item)" [title]="ragStatusTitle(item)">
                      @if (isRagProcessing(item)) {
                        <i-tabler class="icon-14 rag-spin" name="loader-2"></i-tabler>
                      }
                      {{ ragStatusLabel(item) }}
                    </span>
                    @if (canSendToRag(item)) {
                      <button type="button" class="xr-btn xr-btn--soft xr-btn--icon rag-btn rag-btn--send"
                        [attr.aria-label]="ragSendLabel(item)"
                        [matTooltip]="ragSendLabel(item)" matTooltipPosition="above"
                        (click)="sendToRag($event, item)">
                        <i-tabler class="icon-18" name="brain"></i-tabler>
                      </button>
                    }
                    @if (canRemoveFromRag(item)) {
                      <button type="button" class="xr-btn xr-btn--soft xr-btn--icon rag-btn rag-btn--remove"
                        [attr.aria-label]="ragRemoveLabel()"
                        [matTooltip]="ragRemoveLabel()" matTooltipPosition="above"
                        (click)="removeFromRag($event, item)">
                        <span class="brain-off">
                          <i-tabler class="icon-16" name="brain"></i-tabler>
                          <i-tabler class="icon-16 slash" name="slash"></i-tabler>
                        </span>
                      </button>
                    }
                  </div>
                } @else {
                  <span class="nxe-list-muted">—</span>
                }
              </td>
            </tr>
            }

            @if (!item.isLeaf) {
            <!-- Cartella trascinabile e zona di rilascio -->
            <tr class="drop-list-folder"
            [ngClass]="{ 'nxe-list-row-selected': isSelected(item), 'nxe-list-row-archive': isArchiveRoot(item) }"
            (dblclick)="open($event, item)"
            (click)="folderClick($event, item)"
            (cdkDragStarted)="onDragStart($event, item)"
            [cdkDragData]="selectedNodes" cdkDrag
            [id]="'folder'+item.id"
            >
              <td class="nxe-list-name">
                <div class="drop-list-folder">
                  <div class="nxe-icons-wrapper">
                    <div class="nxe-icons-wrapper-inner" [title]="item.name | nxeFolderName">
                      <div class="nxe-icons-icon nxe-kind nxe-kind--sm nxe-kind--folder" cdkDragHandle>
                        <i-tabler class="icon-20 nxe-folder-glyph" name="folder"></i-tabler>
                      </div>
                      <div class="nxe-icon-text">{{ item.name | nxeFolderName }}</div>
                    </div>
                      <div *cdkDragPreview>
                        @for(node of selectedNodes; track $index){
                          <div class="drag-item-preview">
                            <i-tabler class="icon-24 icon-file" name="folder-filled"></i-tabler>
                            <div class="nxe-icon-text">{{ node.name | nxeFolderName }}</div>
                          </div>
                        }
                      </div>
                      <div class="nxe-list-placeholder" *cdkDragPlaceholder></div>
                  </div>
                  <div class="drop drop-list drop-zone pp3" [id]="item.id+''"
                  cdkDropList
                  [cdkDropListData]="item"
                  [cdkDropListConnectedTo]="connectedButMe(item)"
                  (cdkDropListDropped)="onDragDrop($event,item)">
                  </div>
                </div>
              </td>
              <td>{{ 'filemanager.ui.type_folder' | translate }}</td>
              <td class="nxe-list-muted">—</td>
              <td class="nxe-list-nowrap">{{ modifiedAt(item) }}</td>
              <td class="nxe-list-muted">—</td>
            </tr>
            }
          }
        </tbody>
      </table>
    </div>

    @if (!items.length) {
      <div class="xr-empty nxe-empty">{{ 'filemanager.ui.empty' | translate }}</div>
    }
  </div>
</div>
